export const markets = [
  "AD",
  "AE",
  "AL",
  "AT",
  "AU",
  "BA",
  "BE",
  "BG",
  "BH",
  "BY",
  "CH",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "EG",
  "ES",
  "FI",
  "FR",
  "GR",
  "HK",
  "HR",
  "HU",
  "ID",
  "IL",
  "IN",
  "IT",
  "JO",
  "JP",
  "KW",
  "KZ",
  "LB",
  "LI",
  "LT",
  "LU",
  "LV",
  "MC",
  "MD",
  "ME",
  "MK",
  "MT",
  "MY",
  "NL",
  "NO",
  "NZ",
  "OM",
  "PH",
  "PL",
  "PS",
  "QA",
  "RO",
  "RS",
  "RU",
  "SA",
  "SE",
  "SG",
  "SI",
  "SK",
  "TH",
  "TR",
  "TW",
  "UA",
  "VN",
  "XK",
  "ZA",
  "DZ",
  "GB",
  "IE",
  "MA",
  "PT",
  "TN",
  "IS",
  "AR",
  "BR",
  "UY",
  "BO",
  "CA",
  "CL",
  "DO",
  "PY",
  "US",
  "CO",
  "EC",
  "MX",
  "PA",
  "PE",
  "CR",
  "GT",
  "HN",
  "NI",
  "SV",
]

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]
